import signInAuthProvider, { apiAccessScope } from './auth/signInAuthProvider';
import { getStoredAccessToken } from './storage/UnitySessionStorage';
import { localLogout } from './auth/authActions';

export const getMergedConfig = (accessToken, config) => {
  if (config?.headers?.Authorization) {
    return config;
  } else {
    if (config?.headers) {
      const headers = config.headers;
      const combinedHeaders = {
        ...headers,
        Authorization: `Bearer ${accessToken}`,
      };
      config.headers = combinedHeaders;
      return config;
    } else {
      return {
        ...config,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
    }
  }
};

export const handleResponseErrors = async error => {
  if (error?.response?.status === 401) {
    if (process.env.REACT_APP_LOCAL_AUTH === 'true') {
      localLogout();
    } else {
      const account = signInAuthProvider.getActiveAccount();
      if (!account) {
        return;
      }
      await signInAuthProvider.acquireTokenSilent({
        scopes: [apiAccessScope],
        account: account,
      });
    }
  }
};

export const getAccessToken = async () => {
  if (process.env.REACT_APP_LOCAL_AUTH === 'true') {
    return getStoredAccessToken();
  } else {
    const account = signInAuthProvider.getActiveAccount();
    if (!account) {
      return '';
    }
    const token = await signInAuthProvider.acquireTokenSilent({
      scopes: [apiAccessScope],
      account: account,
    });
    return token.accessToken;
  }
};
